import NoshowIcon from '@material-ui/icons/Lock';
import NoshowEdit from './NoshowEdit';

export default {
  edit: NoshowEdit,
  icon: NoshowIcon,
};
